import { render, staticRenderFns } from "./OrderPurcharseAttentionAdd.vue?vue&type=template&id=5093f1c0"
import script from "./OrderPurcharseAttentionAdd.vue?vue&type=script&lang=js"
export * from "./OrderPurcharseAttentionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports